import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Call } from "../../../api/apiCall";
import { LogItemComplete } from "../../../api/logItem";


const columns: GridColDef[] = [
    { field: "prgName", headerName: "Progetto", flex: 0.7, minWidth: 80 },
    { field: "phaseName", headerName: "Fase", flex: 0.7, minWidth: 80 },
    { field: "userName", headerName: "Utente", flex: 0.7, minWidth: 80 },
    { field: "contentType", headerName: "Contesto", flex: 1, minWidth: 120 },
    { field: "action", headerName: "Azione", flex: 1, minWidth: 100 },
    { field: "value", headerName: "Valore", flex: 2, minWidth: 180 },
    {
    field: "accessDate",
    headerName: "Data di accesso",
    flex: 1,
    minWidth: 140,
    valueGetter: (value, row) => {
        // Use row.accessDate instead of params.value
        const accessDate = row.accessDate;
        if (!accessDate) return "Data non disponibile";
        
        try {
            return new Date(accessDate).toLocaleString('it-IT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        } catch (error) {
            console.error('Error formatting date:', error, accessDate);
            return "Data non valida";
        }
    },
    sortComparator: (v1, v2) => {
        // Fix the sort comparator to handle the formatted strings
        if (!v1 || v1 === "Data non disponibile") return 1;
        if (!v2 || v2 === "Data non disponibile") return -1;
        
        try {
            const date1 = new Date(v1).getTime();
            const date2 = new Date(v2).getTime();
            return date1 - date2;
        } catch (error) {
            return 0;
        }
    },
},
];

const LogsList: React.FC = () => {
    const [rows, setRows] = useState<LogItemComplete[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogs = async () => {
            setLoading(true);
            const res = await Call("logs/list", "GET");
            const data = await res.json();
            if (res.ok && data.success) {
                setRows(
                    data.logs.map((log: any, idx: number) => ({
                        id: idx,
                        ...log,
                        accessDate: log.accessDate
                    }))
                );
            }
            setLoading(false);
        };
        fetchLogs();
    }, []);

    return (
        <Box sx={{ width: "100%", p: { xs: 1, md: 2 } }}>
            <Paper sx={{ p: { xs: 1.5, md: 2 }, mb: 2, borderRadius: (theme) => theme.shape.borderRadius }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 500 }}>Logs</Typography>
                <DataGrid
                    autoHeight
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: 20 },
                        },
                    }}
                    pageSizeOptions={[20, 50, 100]}
                    sx={{
                        bgcolor: 'background.default',
                        borderRadius: (theme) => theme.shape.borderRadius,
                        border: (theme) => `1px solid ${theme.palette.divider}`,
                        fontSize: '0.95rem',
                    }}
                />
            </Paper>
        </Box>
    );
};

export default LogsList;